import { Component, OnInit, Input } from '@angular/core';
import { DateHelper } from '../../helpers/date.helper';
import { ParametreModel } from '../../../parametrage/listes/parametres/parametre.model';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-eleve-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoEleveComponent implements OnInit {
  @Input() public eleve: any;
  @Input() public isMenuActionAffiche: boolean = false;

  public bool1Label: string = '';
  public bool2Label: string = '';
  public isBool1Hidden: boolean = true;
  public isBool2Hidden: boolean = true;

  constructor(
    private http: HttpClient
  ) { }

  ngOnInit() {
    const param = new ParametreModel();
    Observable.forkJoin(
      param.getResource('default', 'get').call(this.http, 'getParametreObject', ['CHAMP_ELEVE_ANNEE', 'BOOL_01']),
      param.getResource('default', 'get').call(this.http, 'getParametreObject', ['CHAMP_ELEVE_ANNEE', 'BOOL_02']),
    ).subscribe(data => {
      const [bool_01, bool_02] = data;
      if (bool_01 === null || !bool_01['valeur']) {
        this.isBool1Hidden = true;
      } else {
        this.isBool1Hidden = false;
        this.bool1Label = bool_01['valeur'];
      }
      if (bool_02 === null || !bool_02['valeur']) {
        this.isBool2Hidden = true;
      } else {
        this.isBool2Hidden = false;
        this.bool2Label = bool_02['valeur'];
      }
    });
  }

  getEleveNaissance() {
    return DateHelper.dateBDD2Date(this.eleve.dateNaissStr);
  }
  getEleveNaissanceString() {
    const dateNaiss = this.getEleveNaissance();
    if (!dateNaiss) {
      return '';
    }
    return dateNaiss.toLocaleDateString();
  }
  getAge() {
    const dateNaiss = this.getEleveNaissance();
    if (!dateNaiss) {
      return null;
    }
    const naissAnnee = dateNaiss.getFullYear();
    const naissMois = dateNaiss.getMonth(); //janvier=0
    const naissJour = dateNaiss.getDay();
    const dateCalcul = new Date;
    let age = dateCalcul.getFullYear() - naissAnnee;
    if (naissMois > dateCalcul.getMonth()) {
      age += 1;
    } else if (naissMois === dateCalcul.getMonth() && naissJour >= dateCalcul.getDay()) {
      age += 1;
    }
    return age;
  }
  getNomFamille() {
    return this.eleve && this.eleve.famille ? this.eleve.famille.nom : this.eleve.familleNom;
  }

}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/eleve/info/info.component.ts